var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    rx: 4,
    fill: "#1EC252",
    fillOpacity: 0.0977891
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2919 3H5.79647C4.80538 3 4 3.80534 4 4.79647V12.2919C4 13.2521 4.80534 14.0574 5.79647 14.0574H6.97348V15.2345C6.97348 16.2255 7.74771 17 8.73903 17H16.2345C17.2255 17 18 16.2258 18 15.2345V7.73903C18 6.74795 17.2258 5.97348 16.2345 5.97348H15.0574V4.79647C15.0574 3.80538 14.2521 3 13.2919 3ZM8.42923 14.0572H13.2919C14.2521 14.0572 15.0574 13.2518 15.0574 12.2916V7.42895H16.2345C16.3274 7.42895 16.3893 7.45988 16.4513 7.52191C16.5133 7.58395 16.5443 7.6458 16.5443 7.73876V15.2342C16.5443 15.3271 16.5133 15.389 16.4513 15.451C16.3893 15.5131 16.3274 15.544 16.2345 15.544H8.73903C8.64607 15.544 8.58422 15.5131 8.52218 15.451C8.46015 15.389 8.42922 15.3271 8.42922 15.2342L8.42923 14.0572ZM5.79651 4.48644H13.2919C13.3849 4.48644 13.4468 4.51736 13.5088 4.5794C13.5708 4.61032 13.6017 4.70328 13.6017 4.79625V12.2917C13.6017 12.3846 13.5708 12.4465 13.5088 12.5085C13.4468 12.5706 13.3849 12.6015 13.2919 12.6015H5.79651C5.70355 12.6015 5.61059 12.5706 5.57966 12.5085C5.51763 12.4465 5.4867 12.3846 5.4867 12.2917V4.79625C5.4867 4.70328 5.51763 4.61032 5.57966 4.5794C5.61059 4.51736 5.70355 4.48644 5.79651 4.48644Z",
    fill: "#1EC252",
    stroke: "#E9F9EE",
    strokeWidth: 0.32
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ed64891d.svg";
export { ForwardRef as ReactComponent };